import { Component, Input } from '@angular/core';
import { CREDIT_CARD_PROCESSORS } from 'src/app/core/constants';
import { CreditCard, PaymentMethod, PaymentMethodType } from 'src/app/core/models';

@Component({
  selector: 'app-payment-method-details',
  templateUrl: './payment-method-details.component.html',
  styleUrls: ['./payment-method-details.component.scss'],
})
export class PaymentMethodDetailsComponent {
  @Input() paymentMethod!: PaymentMethod;
  readonly PaymentMethodType = PaymentMethodType;

  constructor() {}

  getLogoUrl(creditCard: CreditCard) {
    return CREDIT_CARD_PROCESSORS.find((p) => p.value === creditCard.processor)?.logoUrl;
  }
}
